import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ProjektQuerySorterConfig } from 'fa-kt.types';
import { ProjektService } from '../service';

@Component({
  selector: 'fa-kt-projekt-sorter',
  templateUrl: './projekt-sorter.component.html',
  styleUrls: ['./projekt-sorter.component.css'],
})
export class ProjektSorterComponent {
  public ProjektSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public projekt: ProjektService,
  ) {
    this.ProjektSorterConfig = ProjektQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
